<template>
	<el-tabs type="border-card">
		<el-tab-pane label="页面模板">
			<el-table :data="tableData" style="width: 100%" stripe>
				<el-table-column prop="id" label="ID" width="100">
				</el-table-column>
				<el-table-column prop="paixu" label="排序" width="200">
					<el-input-number v-model="num" controls-position="right" size="mini"></el-input-number>
				</el-table-column>
				<el-table-column prop="biaoti" label="标题" width="180">
				</el-table-column>
				<el-table-column prop="leixing" label="类型" width="180">
				</el-table-column>
				<el-table-column prop="leixing" label="设置默认" width="180">
					<el-switch v-model="value" active-color="#13ce66" inactive-color="#ff4949">
					</el-switch>
				</el-table-column>
				<el-table-column prop="date" label="操作">
					<el-button icon="el-icon-edit" size="small"></el-button>
					<el-button icon="el-icon-close" size="small"></el-button>
				</el-table-column>
			</el-table>
		</el-tab-pane>
		<el-tab-pane label="添加页面模板">
			<div class="box">
				<div class="zhangshiqu">
					<div class="zhanshi_tou"></div>
					<div class="zhanshi_nei"></div>
					<div class="zhanshi_dibu"></div>
				</div>
			<div class="tianjiaqu">
					<div class="tianjia_tou">
						<div class="tianjia_zuijian caidan"><i class="el-icon-plus"></i>轮播</div>
						<div class="tianjia_zuijian caidan"><i class="el-icon-plus"></i>分类</div>
						<div class="tianjia_zuijian caidan"><i class="el-icon-plus"></i>搜索</div>
						<div class="tianjia_zuijian caidan"><i class="el-icon-plus"></i>图片</div>
						<div class="tianjia_zuijian caidan"><i class="el-icon-plus"></i>图片4块</div>
						<div class="tianjia_zuijian caidan"><i class="el-icon-plus"></i>商品（2,3）列</div>
						<div class="tianjia_zuijian caidan"><i class="el-icon-plus"></i>商品抢购</div>
						<div class="tianjia_zuijian caidan"><i class="el-icon-plus"></i>商品1列</div>
					</div>
					<div class="tianjia_dibu">
						<el-button class="baocun" type="warning" size="small">保存</el-button>
					</div>
				</div>
				
					<div class="shezhiqu left">
					<div class="shezhi_tou">轮播</div>
					<div v-if="lunbo">
						<el-table :data="lun" style="width: 100%" class="shezhi_neirong">
							<el-table-column prop="lian" label="链接" width="190">
								<el-input></el-input>
							</el-table-column>
							<el-table-column prop="tu" label="图标" label-width="180px">
								<Shangwenjian leixing="tu"></Shangwenjian>
							</el-table-column>
							<el-table-column label-width="180px">
								<el-link :underline="false">删</el-link>
							</el-table-column>
						</el-table>
						<el-link :underline="false" type="primary" class="zenjia">新增+</el-link>
					</div>
					<div>
						<el-button class="xuanzetu">选择图片</el-button>
						<!-- <el-input size="small" style="margin-left: 40px;"> <template slot="prepend" size="small">图片跳转链接</template></el-input> -->
					</div>
				</div>
			</div>
		</el-tab-pane>
	</el-tabs>

</template>

<script>
	import Shangtu from '../../zujian/Shangtu.vue'
	import Shangwenjian from '../../zujian/Shangwenjian.vue'
	export default {
		data() {
			return {
				tableData: [{
					id: '85',
					paixu: '',
					biaoti: '甜甜',
					leixing: 'index',
					date: '2016-05-04 10:35:44'
				}],
				value: true,
				num: 1,
				lun: [{
					lian: '',
					tu: ''
				}],
				tu: '',
				lunbo: 0
			}
		},
		components: {
			Shangtu,
			Shangwenjian
		},
		methods: {
			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
			},
			handleCurrentChange(val) {
				console.log(`当前页: ${val}`);
			}
		},
	}
</script>

<style>
	.box {
		float: left;
		/* position: relative; */
		width: 100%;
		/* height: auto; */
		display: flex;
	}

	.zhangshiqu {
		/* float: left; */
		width: 328px;
		height: auto;
		border: 1px solid #ddd;
		border-radius: 10px;
		background: #fff;
		padding: 10px;
		overflow: hidden;
		margin-bottom: 150px;
		background-color: white;
		margin: 0 auto;
	/* 	position: absolute;
		left: 50%;
		margin-left: -164px; */
	}

	.zhanshi_tou {
		position: relative;
		height: 44px;
	}

	.zhanshi_tou:before {
		content: "";
		position: absolute;
		top: 15px;
		left: 112px;
		height: 8px;
		width: 8px;
		background: #ddd;
		border-radius: 8px;
	}

	.zhanshi_tou:after {
		content: "";
		position: absolute;
		top: 15px;
		left: 128px;
		height: 8px;
		width: 50px;
		background: #ddd;
		border-radius: 8px;
	}

	.zhanshi_nei {
		width: 100%;
		border: 1px solid #ddd;
		height: auto;
		min-height: 500px;
	}

	.zhanshi_dibu {
		height: 24px;
		width: 60px;
		margin: 15px auto 5px;
		border: 1px solid #ddd;
		border-radius: 5px;
	}

	.tianjiaqu {
		width: 160px;
		height: 360px;
		background: #fdfdfd;
		border: 1px solid #ddd;
		border-radius: 3px;
		position: fixed;
		top: 130px;
		left: 100px;
		box-shadow: 0 0 8px rgba(0, 0, 0, 0.1);
		z-index: 99999999;
		min-height: 150px;
	}

	.tianjia_tou {
		padding: 10px 10px 5px;
		height: auto;
		display: flex;
		flex-wrap: wrap;
		/* float: left; */
	}

	.tianjia_dibu {
		float: left;
		padding: 10px;
		text-align: right;
		border-top: 1px dotted #ddd;
		position: absolute;
		height: 50px;
		bottom: 0;
		width: 100%;
		box-sizing: border-box;
	}

	.tianjia_zuijian {
		float: left;
		padding: 5px 9px 5px 29px;
		margin: 0 5px 5px 0;
		text-align: left;
		box-sizing: border-box;
		position: relative;
		border-radius: 4px;
		cursor: pointer;
	}

	.tianjia_zuijian i {
		position: absolute;
		left: 7px;
		top: 7px;
	}

	.caidan {
		color: #788188;
		font-size: 14px;
	}

	.baocun {
		margin-bottom: 10px;
	}

	.shezhiqu {
		position: relative;
		float: left;
		width: 700px;
		height: auto;
		background: #fdfdfd;
		color: white;
		padding: 15px 10px;
		margin-left: 18px;
		border: 1px solid #ddd;
		border-radius: 5px;
		margin-top: 55px;
		margin-bottom: 150px;
		min-height: 200px;
	}

	.shezhiqu:after {
		content: '';
		position: absolute;
		width: 0;
		height: 0;
		border: 8px solid;
	}

	.left:after {
		border-right-color: #CCCCCC;
		/* border: 1px solid #CCCCCC; */
		top: 50%;
		right: 100%;
		margin-top: -9px;
	}

	.shezhi_tou {
		border-bottom: 1px solid #ddd;
		padding-bottom: 7px;
		margin-bottom: 20px;
		color: #788188;
		font-size: 14px;
	}

	.shezhi_neirong {
		width: 100%;
		max-width: 100%;
		margin-bottom: 20px;
	}

	.zenjia {
		text-align: center;
		width: 100%;
	}
	.xuanzetu{
		margin-left:60px;
	}
</style>
